import { createContext } from 'react';

const formDataContext = createContext();

export default formDataContext;
